<template>
  <span class="link-cell-renderer">
    <router-link
      :id="uid"
      :to="to"
      :class="props.params.classes"
      :aria-label="`Link to ${companyName}`"
    >
      {{ companyName }}
    </router-link>
  </span>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const companyName = computed(() => props.params.data?.Company ?? '')

const to = computed(() => ({
  name: 'companies:members',
  params: { id: props.params.data?.ID },
}))

const uid = computed(() =>
  `ag-grid-cell-renderer-PgeCompaniesLinkCellRenderer-row-index-${props.params.rowIndex}`,
)

const navigateWithEnter = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault()
    props.params.eGridCell.querySelector('a').click()
  }
}

onMounted(() => props.params.eGridCell.addEventListener('keyup', navigateWithEnter))
onUnmounted(() => props.params.eGridCell.removeEventListener('keyup', navigateWithEnter))
</script>
